import t from "./design-system.es126.js";
import { errorBannerKey as n } from "./design-system.es12.js";
const i = () => {
  const r = t();
  return { emitter: r, open: (o) => {
    r.emit("open", o);
  }, close: () => {
    r.emit("close");
  } };
}, m = () => {
  const r = i();
  return r.install = (e) => {
    e.config.globalProperties.$errorBannerEmitter = r.emitter, e.config.globalProperties.$error = r.open, e.provide(n, r);
  }, r;
};
export {
  i as createErrorBanner,
  m as createErrorBannerGlobal
};
//# sourceMappingURL=design-system.es8.js.map
